import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const MentionsLegales = () => (
            <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        MENTIONS LEGALES
      </Typography>

      <Divider className="cgu-divider" />

      <Typography
        variant="subtitle2"
        align="center"
        className="cgu-date"
        gutterBottom
      >
        Dernière mise à jour : [18/09/2025]
      </Typography>

      <Typography paragraph>
        Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique, il est précisé aux utilisateurs du site 
        {" "}  
        <a
            href="https://cooptaleo.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
           cooptaleo.com
        </a> {" "} 
         l’identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
      </Typography>

      <Typography variant="h6" gutterBottom>
         1. Éditeur du site
      </Typography>
      <Typography paragraph>
        CIT MENA INFORMATION TECHNOLOGY CONSULTANCY LLC<br/>
        LLC au capital social de 30 000 AED<br/>
        Siège social : Office F1 – 261 Hor Al Anz – Dubai – United Arab Emirates<br/>
        Company Registration No. : 2426887<br/>
        Main License No. : 1422254<br/>
        Contact :{" "}   
          <a
            href="mailto:contact@cooptaleo.com"
            style={{ textDecoration: "underline", color: "blue" }}
          >
            contact@cooptaleo.com
          </a>{" "}
      </Typography>

      <Typography variant="h6" gutterBottom>
        2. Hébergeur
      </Typography>
      <Typography paragraph>
        OVHcloud<br/>
        2 rue Kellermann – 59100 Roubaix – France<br/>
        <a
            href="https://www.ovh.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
           www.ovh.com
        </a> {" "} 
      </Typography>

      <Typography variant="h6" gutterBottom>
        3. Conception et développement
      </Typography>
      <Typography paragraph>
        Cooptaleo : {" "}   
        <a
          href="mailto:contact@cooptaleo.com"
          style={{ textDecoration: "underline", color: "blue" }}
        >
          contact@cooptaleo.com
        </a>{" "}
      </Typography>

      <Typography variant="h6" gutterBottom>
        4. Crédits photos et illustrations
      </Typography>
      <Typography paragraph>
        Banques d’images libres de droits ou créations internes.
      </Typography>

      <Typography variant="h6" gutterBottom>
        5. Conditions d’utilisation
      </Typography>
      <Typography paragraph>
        L’utilisation du site {" "}  
        <a
            href="https://cooptaleo.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
           cooptaleo.com
        </a> {" "} implique l’acceptation pleine et entière des conditions générales d’utilisation décrites dans les {" "}       
         <a
            href="/cgu"
            style={{ textDecoration: "underline", color: "blue" }}
          >
          Conditions Générales d’Utilisation (CGU)
        </a>.
      </Typography>

      <Typography variant="h6" gutterBottom>
         6. Données personnelles
      </Typography>
      <Typography paragraph>
         Pour toute information relative au traitement de vos données, veuillez consulter notre  {" "}         
         <a
            href="/confidentiality"
            style={{ textDecoration: "underline", color: "blue" }}
          >
          Politique de confidentialité (RGPD)
        </a>.
      </Typography>

      <Typography variant="h6" gutterBottom>
         7. Responsabilité
      </Typography>
      <Typography paragraph>
        L’Éditeur met tout en œuvre pour assurer l’exactitude des informations et la disponibilité du site, mais ne saurait être tenu responsable en cas d’erreurs, d’omissions ou d’indisponibilité temporaire.
      </Typography>
    </Box>
  </Container>
     <Footer />

  </>
);

export default MentionsLegales;
